import { FC } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type LogoProps = PropsWithClassName & { alt?: string };

const Default: FC<LogoProps> = ({ className, alt = 'COMMAND' }) => {
  return <img src="/assets/zde-logo.svg" alt={alt} className={cn('w-[320px] max-w-full', className)} />;
};

const LogoOnly: FC<LogoProps> = ({ className, alt = 'COMMAND' }) => {
  return <img src="/assets/zde-logo.svg" alt={alt} className={cn('w-[240px] max-w-full', className)} />;
};

export default { Default, LogoOnly };
